import type { BoxProps } from '@mui/material';
import { Box } from '@mui/material';

export const SectionBody = (props: BoxProps) => {
  return <Box p={6} {...props} />;
};
